var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"env-border"}),_c('div',{staticClass:"env-header"},[_c('v-flex',{staticClass:"vf fl",attrs:{"xs10":"","offset-xs1":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }